import { isEmpty } from 'lodash';

export function hasValidKeyMoments(event, momentType) {
  if (!momentType) {
    return !isEmpty(event?.keyDates) || !isEmpty(event?.keyMoments)
  }

  return !isEmpty(event?.keyDates?.[momentType]) || !isEmpty(event?.keyMoments?.[momentType])
}
